import {
  ComboboxOption as HeadlessComboboxOption,
  type ComboboxOptionProps as HeadlessComboboxOptionProps,
} from "@headlessui/react";
import { classNames } from "../../utils/classNames";

export function SearchListboxOption({
  className,
  children,
  ...props
}: {
  className?: string;
} & HeadlessComboboxOptionProps) {
  return (
    <HeadlessComboboxOption
      className={({ focus, disabled }) =>
        classNames({
          "px-4 py-3 rounded-xl bg-primary flex items-center gap-4 cursor-default": true,
          "text-sm/5 font-medium": true,
          "[&>[data-slot=icon]]:size-4 [&>[data-slot=avatar]]:size-6": true,
          "bg-secondary": focus,
          "opacity-50": disabled,
        })
      }
      {...props}
    >
      {children}
    </HeadlessComboboxOption>
  );
}
